import { createSlice } from '@reduxjs/toolkit';
import Template from '../../util/Template';
export const saveFormSlice = createSlice({
  name: 'saveForm',
  initialState: {
    title: '',
    content: Template,
    selectedCourse: { id: 16305, Name: '', Ch_name: '' },
    allImageLink: '',
  },
  reducers: {
    update: (state, action) => {
      state.title = action.payload.title;
      state.content = action.payload.content;
      state.selectedCourse = {
        id: action.payload.selectedCourse.id,
        Name: action.payload.selectedCourse.Name,
        Ch_name: action.payload.selectedCourse.Ch_name,
      };
      state.allImageLink = action.payload.allImageLink;
    },
    clearForm: (state) => {
      state.title = '';
      state.content = Template;
      state.selectedCourse = { id: 16305, Name: '', Ch_name: '' };
      state.allImageLink = '';
    },
  },
});
export const { update, clearForm } = saveFormSlice.actions;
export const saveForm = (state) => state.saveForm;
export default saveFormSlice.reducer;